export default class OfferSummarySerializer {
  static serialize(data) {
    return {
      totalOffers: data.totalOffers,
      averageTargetPay: data.averageTargetPay,
      averageMaxPay: data.averageMaxPay,
      averageCarrierOffer: data.averageCarrierOffer,
      averageCounterOffer: data.averageCounterOffer
    };
  }

  static deSerialize(data) {
    return {
      totalOffers: data.totalOffers,
      averageTargetPay: data.averageTargetPay,
      averageMaxPay: data.averageMaxPay,
      averageCarrierOffer: data.averageCarrierOffer,
      averageCounterOffer: data.averageCounterOffer
    };
  }
}